var map = {
  "./code-example/element.js": [
    "66178",
    "8807",
    "3536",
    "5500",
    "5759",
    "6213",
    "8769"
  ],
  "./dropdown/element.js": [
    "18399",
    "3892"
  ],
  "./live-sample-result/element.js": [
    "72620",
    "8807",
    "2801",
    "3536",
    "9446",
    "8684",
    "5500",
    "4765"
  ],
  "./observatory-tests-and-scores/element.js": [
    "65034",
    "665"
  ],
  "./play-runner/element.js": [
    "18103",
    "8807",
    "9446",
    "8684",
    "189"
  ],
  "./search-button/element.js": [
    "12233",
    "391"
  ],
  "./survey/element.js": [
    "2211",
    "8807",
    "3536",
    "2448"
  ],
  "./ix-tab-wrapper/element.js": [
    "17739",
    "3649"
  ],
  "./placement-sidebar/element.js": [
    "46907",
    "8807",
    "2801",
    "6125",
    "3895",
    "8349",
    "8483"
  ],
  "./placement-hp-main/element.js": [
    "90445",
    "8807",
    "2801",
    "6125",
    "3895",
    "8349",
    "736"
  ],
  "./toggle-sidebar/element.js": [
    "37775",
    "3536",
    "9398"
  ],
  "./user-menu/element.js": [
    "1260",
    "3536",
    "2074",
    "268"
  ],
  "./interactive-example/element.js": [
    "97877",
    "8807",
    "8016",
    "8551",
    "4338",
    "7667",
    "5837",
    "9130",
    "8722",
    "7945",
    "5353",
    "3536",
    "9446",
    "8684",
    "1048",
    "5293",
    "5500",
    "9577",
    "5759",
    "9133",
    "6213",
    "3649",
    "7731",
    "2656"
  ],
  "./copy-button/element.js": [
    "28553",
    "3536",
    "5759",
    "6078"
  ],
  "./observatory-comparison-table/element.js": [
    "93305",
    "8169",
    "5066"
  ],
  "./sidebar-filter/element.js": [
    "98903",
    "7461"
  ],
  "./issues-table/element.js": [
    "89787",
    "7816"
  ],
  "./scrim-inline/element.js": [
    "37142",
    "2801",
    "1342"
  ],
  "./switch/element.js": [
    "32013",
    "476"
  ],
  "./collection-save-button/element.js": [
    "84500",
    "3536",
    "917",
    "1624"
  ],
  "./contributor-list/element.js": [
    "20082",
    "533"
  ],
  "./button/element.js": [
    "50272",
    "3536",
    "176"
  ],
  "./homepage-search/element.js": [
    "73594",
    "1739"
  ],
  "./modal/element.js": [
    "86499",
    "3536",
    "917"
  ],
  "./color-theme/element.js": [
    "56379",
    "3892",
    "6955"
  ],
  "./about-team-member/element.js": [
    "22928",
    "2633"
  ],
  "./content-feedback/element.js": [
    "48665",
    "3536",
    "770"
  ],
  "./play-console/element.js": [
    "4976",
    "1048"
  ],
  "./ix-tab/element.js": [
    "49000",
    "9133",
    "7731"
  ],
  "./observatory-header-link/element.js": [
    "55072",
    "8169",
    "6681"
  ],
  "./curriculum-tabs/element.js": [
    "87163",
    "6339"
  ],
  "./placement-bottom/element.js": [
    "68543",
    "8807",
    "2801",
    "6125",
    "3895",
    "8349",
    "4849"
  ],
  "./image-history/element.js": [
    "31061",
    "6656"
  ],
  "./not-found/element.js": [
    "60884",
    "5093",
    "1589"
  ],
  "./placement-note/element.js": [
    "83294",
    "3895"
  ],
  "./compat-table-lazy/element.js": [
    "27907",
    "2074",
    "8911",
    "1916"
  ],
  "./site-search/element.js": [
    "6882",
    "3536",
    "9222"
  ],
  "./placement-no/element.js": [
    "43028",
    "6125"
  ],
  "./play-controller/element.js": [
    "4406",
    "9577"
  ],
  "./placement-top/element.js": [
    "61485",
    "8807",
    "2801",
    "6125",
    "3895",
    "8349",
    "3580"
  ],
  "./observatory-form/element.js": [
    "14793",
    "8807",
    "3536",
    "7013",
    "4531"
  ],
  "./observatory-results/element.js": [
    "59011",
    "3536",
    "8169",
    "7013",
    "5066",
    "4045",
    "6681",
    "8896",
    "642"
  ],
  "./about-tabs/element.js": [
    "94856",
    "7509"
  ],
  "./observatory-human-duration/element.js": [
    "32570",
    "8169",
    "8896"
  ],
  "./playground/element.js": [
    "6067",
    "8807",
    "8016",
    "8551",
    "4338",
    "7667",
    "5837",
    "9130",
    "8722",
    "7945",
    "3536",
    "9446",
    "8684",
    "1048",
    "5293",
    "9577",
    "917",
    "8431"
  ],
  "./ix-tab-panel/element.js": [
    "89948",
    "9133"
  ],
  "./play-editor/element.js": [
    "74580",
    "8016",
    "8551",
    "4338",
    "7667",
    "5837",
    "9130",
    "8722",
    "7945",
    "9446",
    "5293"
  ],
  "./themed-image/element.js": [
    "19425",
    "2713"
  ],
  "./writer-open-editor/element.js": [
    "91186",
    "3536",
    "833"
  ],
  "./progress-bar/element.js": [
    "42678",
    "7013"
  ],
  "./compat-table/element.js": [
    "50757",
    "2074",
    "8911"
  ],
  "./login-button/element.js": [
    "56980",
    "3536",
    "3981"
  ],
  "./observatory-rescan-button/element.js": [
    "90811",
    "3536",
    "4045",
    "1519"
  ],
  "./language-always-redirect-button/element.js": [
    "92513",
    "2255",
    "1004"
  ],
  "./language-switcher/element.js": [
    "36403",
    "3892",
    "476",
    "5093",
    "2255",
    "3769"
  ],
  "./search-modal/element.js": [
    "39187"
  ],
  "./writer-reload/element.js": [
    "52084",
    "1042"
  ]
};
function webpackAsyncContext(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
    return __webpack_require__(id);
  });
}

webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 65013;
module.exports = webpackAsyncContext;
